import * as types from 'store/modules/hrms12x/mutation-types'
import { constLabels } from 'assets/js/constLabels.js'
import hrms12x from 'api/hrms12x'
import swal from 'sweetalert'
import hrms12xLabels from 'assets/labels/hrms12x'
import { hrms12xColumns } from 'assets/columns/hrms12x'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    sendMailDisp: true,
    notSendDisp: false,
    labels: hrms12xLabels,
    columns: hrms12xColumns(),
    index: {
      path: {
        path: ''
      },
      table: {
        total: 0,
        rows: []
      }
    },
    sendmail: {},
    response: {
      status: '',
      message: ''
    },
    listFields: {
      en: [],
      th: []
    },
    empmailSelected: [],
    detail: {
      subject: '',
      msg: '',
      attach: '',
      codempid_sender: '',
      codcomp_sender: '',
      reciver: {
        codempid: '',
        email: ''
      }
    },
    detailNotSend: {
      total: 0,
      rows: [
        {
          sender_id: '',
          sender_email: ''
        }
      ]
    }
  },
  getters: {
    [types.GET_HRMS12X_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS12X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS12X_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS12X_LISTFIELDS] (state) {
      return state.listFields
    },
    [types.GET_HRMS12X_EMPEMAIL] (state) {
      return state.empmailSelected
    },
    [types.GET_HRMS12X_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS12X_SENDMAILDISP] (state) {
      return state.sendMailDisp
    },
    [types.GET_HRMS12X_NOTSENDDISP] (state) {
      return state.notSendDisp
    },
    [types.GET_HRMS12X_DETAILNOTSEND] (state) {
      return state.detailNotSend
    }
  },
  mutations: {
    [types.SET_HRMS12X_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].notSend = configLabel.replaceLabelToColumns(state.columns[keyLang].notSend, labels[keyLang])
      }
    },
    [types.SET_HRMS12X_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRMS12X_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS12X_LISTFIELDS] (state, data) {
      state.listFields = data
    },
    [types.SET_HRMS12X_ADD_EMPEMAIL] (state, dataRows) {
      state.empmailSelected = []
      for (var row = 1; row <= dataRows.length; row++) {
        let dataRow = dataRows[row - 1]
        state.empmailSelected.push(dataRow)
      }
      state.sendMailDisp = true
      state.notSendDisp = false
    },
    [types.SET_HRMS12X_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRMS12X_DETAILNOTSEND] (state, data) {
      state.detailNotSend = data
    }
  },
  actions: {
    [types.RECEIVED_HRMS12X_COLUMNS_LABELS] ({ commit }) {
      hrms12x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS12X_COLUMNS, data.labels)
          commit(types.SET_HRMS12X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS12X_INDEX] ({ commit }, searchParams) {
      hrms12x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS12X_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS12X_SENDMAIL] ({ commit, dispatch, state }, params) {
      let referenceButton = params.referenceButton
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      hrms12x.postSendmail(params)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          if (data.total > 0) {
            swal({title: '', text: data.rows[0].response, html: true, type: 'warning'}, function () {
              state.notSendDisp = true
              state.sendMailDisp = false
              params.refCancelEvent()
              commit(types.SET_HRMS12X_DETAILNOTSEND, data)
            })
          } else {
            swal({title: '', text: data.rows[0].response, html: true, type: 'success'}, function () {
              referenceButton.click()
            })
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'warning'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS12X_LISTFIELDS] ({ commit }, searchParams) {
      hrms12x.getListFields()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS12X_LISTFIELDS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS12X_DETAIL] ({ commit }, searchParams) {
      let data = {
        subject: '',
        msg: '',
        attach: '',
        codempid_sender: '',
        codcomp_sender: '',
        reciver: {
          codempid: '',
          email: ''
        }
      }
      commit(types.SET_HRMS12X_DETAIL, data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms12x/index.js